var Masks = {
  init: function() {
    Masks.setMasks();
    console.log('Masks Init!');
  },
  setMasks: function() {
    $('.date-mask').mask('00/00/0000', {placeholder: "__/__/____"});
    $('.datepicker-mask').inputmask('99/99/9999');
    $('.cpf-mask').mask('000.000.000-00', {placeholder: "___.___.___-__"});
    $('.cnpj-mask').mask('00.000.000/0000-00', {placeholder: "__.___.___/____-__"});

    var cpfCnpjOptions = {
      onKeyPress: function(idNumber, e, field, options) {
        var masks = ['000.000.000-009', '00.000.000/0000-00'];
        var mask = idNumber.replace(/\D/g, '').length > 11 ? masks[1] : masks[0];
        $('.cpf-cnpj-mask').mask(mask, options);
      }
    };

    $('.cpf-cnpj-mask').each(function() {
      $(this).mask($(this).val().replace(/\D/g, '').length > 11 ? '00.000.000/0000-00' : '000.000.000-009', cpfCnpjOptions);
    });

    var maskPhone = function (val) {
      return val.replace(/\D/g, '').length === 11 ? '(00) 00000-0000' : '(00) 0000-00009';
    },
    options = {onKeyPress: function(val, e, field, options) {
        field.mask(maskPhone.apply({}, arguments), options);
      }, placeholder: "(__) ____-____" };

    $('.phone').mask(maskPhone, options);
    if ($('.select2-ddi').val() == 'BR') {
      $('.phone-mask').mask(maskPhone, options);
    }
    if ($('#extra_ddi').val() == 'BR') {
      $('.extra-phone-mask').mask(maskPhone, options);
    }
    $('.select2-ddi').on('select2:select', function(e) {
      e.params.data.id === 'BR' ? $('.phone-mask').mask(maskPhone, options) : $('.phone-mask').unmask();
    })
    $('#extra_ddi').change(function() {
      $(this).val() == 'BR' ? $('.extra-phone-mask').mask(maskPhone, options) : $('.extra-phone-mask').unmask();
    })

    Masks.setMoneyMask('.money-mask');
    Masks.setPercentageMask('.percentage-mask');

  },
  unMasks: function() {
    $('.date-mask').unmask();
    $('.cpf-mask').unmask();
    $('.cnpj-mask').unmask();
    $('.zip-code-mask').unmask();
    $('.phone-mask').unmask();
    $('.extra-phone-mask').unmask();
    $('.money-mask, .percentage-mask').maskMoney('destroy');
  },

  setMoneyMask: function(className) {
    $(className).maskMoney({thousands:'.', decimal:',', allowZero:true});
    Masks.setChildrenMasks();
  },

  setPercentageMask: function(className) {
    $(className).maskMoney({thousands:'.', decimal:',', allowZero:true, suffix: ' %' });
    Masks.setChildrenMasks();
  },

  setChildrenMasks: function(className) {
    $(className).each(function(){
      $(this).maskMoney('mask', $(this).val());
    });
  },

  unMaskMoney: function(className) {
    $(className).each(function(){
      $(this).val().maskMoney('unmasked')[0];
    });
  }
}
$(document).ready(function() {
  Masks.init();
})
